export default __webpack_public_path__ + "static/media/icaew_s2.72d4f1f0.png";